import React, { Fragment, useState } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import SystemInfo from "../../util/SystemInfo";


const NavHeader = () => {
    const { navigationHader, setHideMenu, background } = useTheme();

    return (
        <div className="nav-header" style={{ zIndex: 9 }}>
            <Link to="/dashboard" className="brand-logo">
                {background.value === "dark" || navigationHader !== "color_1" ?
                    <img src={SystemInfo?.logoBlanco} style={{ maxWidth: '60%' }} alt="" />
                    :
                    <img src={SystemInfo?.logo} style={{ maxWidth: '60%' }} alt="" />
                }
            </Link>

            <div
                className="nav-control"
                onClick={() => {
                    setHideMenu(old => !old);
                }}
            >
                <div className={`hamburger`}>
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                </div>
            </div>
        </div>
    );
};

export default NavHeader;
